import React from 'react';
import { useTranslation } from 'react-i18next';
const IconWorkspace = () => (
  <svg className="w-12 h-12 sm:w-14 sm:h-14 mx-auto text-brand-emerald shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
    <path strokeWidth="2" d="M4 5h16v14H4z" />
    <path strokeWidth="2" d="M8 9h8M8 13h8M8 17h5" />
  </svg>
);
const IconProperties = () => (
  <svg className="w-12 h-12 sm:w-14 sm:h-14 mx-auto text-brand-emerald shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
    <rect x="4" y="5" width="16" height="14" rx="2" strokeWidth="2" />
    <path strokeWidth="2" d="M9 9h6M9 13h4" />
  </svg>
);

const BASE_CARDS = [
  { id: 'myProperties', key: 'myProperties', descKey: 'myPropertiesDesc', Icon: IconProperties, active: true },
  { id: 'lvWorkspace', key: 'lvWorkspace', descKey: 'lvWorkspaceDesc', Icon: IconWorkspace, active: true },
];

export default function SearchTypeHome({ onSelect }) {
  const { t } = useTranslation();
  const cards = BASE_CARDS;

  return (
    <div className="max-w-4xl mx-auto py-8 sm:py-10 md:py-12 px-3 sm:px-5 w-full min-w-0">
      <h1 className="text-[1.65rem] leading-[1.12] sm:text-4xl sm:leading-[1.1] md:text-5xl md:leading-[1.06] font-sans font-extrabold text-brand-green mb-3 sm:mb-4 tracking-tight whitespace-pre-line">
        {t('home.title')}
      </h1>
      <p className="text-slate-600 mb-3 sm:mb-4 text-lg sm:text-xl md:text-2xl font-semibold leading-snug max-w-3xl whitespace-pre-line">
        {t('home.subtitle')}
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-5 w-full min-w-0 mt-2 sm:mt-3">
        {cards.map(({ id, key, descKey, Icon, active }) => (
          <button
            key={id}
            type="button"
            onClick={() => active && onSelect(id)}
            aria-label={t(`home.${key}`)}
            disabled={!active}
            className={`
              flex flex-col items-center justify-center p-5 sm:p-7 rounded-2xl border-2 min-h-[132px] sm:min-h-[158px] w-full
              transition-all duration-200 active:scale-[0.99]
              ${active
                ? 'border-emerald-400/70 bg-white/95 shadow-card hover:border-amber-400/80 hover:shadow-soft hover:bg-gradient-to-b hover:from-white hover:to-emerald-50/50 text-slate-800 cursor-pointer'
                : 'border-slate-200/80 bg-slate-50/80 text-slate-400 cursor-not-allowed'}
            `}
          >
            <Icon />
            <span className="mt-3.5 text-base sm:text-lg font-bold text-center leading-snug px-1 tracking-tight">
              {t(`home.${key}`)}
            </span>
            <span className="mt-2 text-sm sm:text-base text-slate-600 text-center leading-snug px-1 font-medium">
              {t(`home.${descKey}`)}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
